import { Injectable } from '@angular/core';
import { ApplicationInsightService } from './application-insight.service';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class Logger {
  constructor(
    private readonly applicationInsightService: ApplicationInsightService,
    private readonly envService: EnvService
  ) {}

  logError(error: Error) {
    if (!this.envService.isProduction) {
      console.error(error);
    }
    return this.applicationInsightService.logException(error);
  }
}
